/* LYNE Motion
   Leichte Scroll-Reveal- und Counter-Logik basierend auf IntersectionObserver.
   GSAP-frei. GSAP plus ScrollTrigger und Lenis werden in einem spaeteren Loop
   ergaenzt, sobald die Vendor-Bundles eingespielt sind (siehe lyne-vendor-loader.js).

   Bereitgestellte Verhalten:
   - data-lyne-reveal: fade-up Reveal beim ersten Sichtbarwerden
   - data-lyne-counter: numerischer Counter mit data-lyne-counter-to="22"

   Stand: 2026-05-13. Builder Loop 1. */
(function () {
  'use strict';

  if (typeof window === 'undefined') return;
  if (typeof IntersectionObserver === 'undefined') return;

  var PREFERS_REDUCED = false;
  try {
    PREFERS_REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { /* noop */ }

  // ============ Reveal ============

  function setupReveal() {
    var nodes = document.querySelectorAll('[data-lyne-reveal]:not([data-lyne-reveal-init])');
    if (!nodes.length) return;

    nodes.forEach(function (n) { n.setAttribute('data-lyne-reveal-init', '1'); });

    if (PREFERS_REDUCED) {
      nodes.forEach(function (n) { n.classList.add('is-revealed'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var node = entry.target;
          var delay = parseInt(node.getAttribute('data-lyne-reveal-delay') || '0', 10);
          window.setTimeout(function () {
            node.classList.add('is-revealed');
          }, delay);
          io.unobserve(node);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

    nodes.forEach(function (n) { io.observe(n); });
  }

  // ============ Counter ============

  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

  function animateCounter(node) {
    var target = parseFloat(node.getAttribute('data-lyne-counter-to') || '0');
    var decimals = parseInt(node.getAttribute('data-lyne-counter-decimals') || '0', 10);
    var duration = parseInt(node.getAttribute('data-lyne-counter-duration') || '1400', 10);
    var locale   = node.getAttribute('data-lyne-counter-locale') || 'de-DE';
    var suffix   = node.getAttribute('data-lyne-counter-suffix') || '';
    var prefix   = node.getAttribute('data-lyne-counter-prefix') || '';

    if (PREFERS_REDUCED) {
      node.textContent = prefix + new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(target) + suffix;
      return;
    }

    var startT = performance.now();
    function step(now) {
      var t = Math.min(1, (now - startT) / duration);
      var v = target * easeOut(t);
      node.textContent = prefix + new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(v) + suffix;
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function setupCounters() {
    var nodes = document.querySelectorAll('[data-lyne-counter]:not([data-lyne-counter-init])');
    if (!nodes.length) return;
    nodes.forEach(function (n) { n.setAttribute('data-lyne-counter-init', '1'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    nodes.forEach(function (n) { io.observe(n); });
  }

  function init() {
    setupReveal();
    setupCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
